var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.EmptyStateEntry,{attrs:{"title":_vm.$t('trainings.take-empty'),"text":_vm.$t('trainings.take-empty-description'),"image-src":"/images/empty-take-course.svg"}})
}
var staticRenderFns = []

export { render, staticRenderFns }